import { createContext } from 'react';

const SectionContext = createContext(null);

export default SectionContext;
